/* DevīCo v24.5.3 — cycle product images on hover/focus, reset on exit */
(function () {
  'use strict';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!finePointer || reduceMotion) return;
  const delay = 950;
  function initPreview(link) {
    const frames = Array.from(link.querySelectorAll('[data-preview-frame]'));
    if (frames.length < 2 || link.dataset.previewReady === 'true') return;
    link.dataset.previewReady = 'true';
    let index = 0, timer = null;
    function show(next) {
      frames[index].classList.remove('is-active');
      index = (next + frames.length) % frames.length;
      frames[index].classList.add('is-active');
    }
    function start() {
      if (timer || document.hidden) return;
      link.classList.add('is-previewing');
      timer = window.setInterval(() => show(index + 1), delay);
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
      link.classList.remove('is-previewing');
      frames.forEach((frame, i) => frame.classList.toggle('is-active', i === 0));
      index = 0;
    }
    link.addEventListener('pointerenter', start);
    link.addEventListener('pointerleave', stop);
    link.addEventListener('focus', start);
    link.addEventListener('blur', stop);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  }
  function init() { document.querySelectorAll('[data-product-preview]').forEach(initPreview); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
